define('AwaLabs.CMSFullBanner.CCTFullBanner', [
	'CCTFullBanner.View'
],
function AwaLabsCMSFullBannerCCTFullBanner(
	CCTFullBannerView
) {
	'use strict';

	return {
		mountToApp: function mountToApp(application) {
			var cmsComponent = application.getComponent('CMS');

			cmsComponent.registerCustomContentType({
				id: 'cct_awalabs_cctfullbanner',
				view: CCTFullBannerView
			});
		}
	};
});
